import type { ModelItem } from '@app/api/Positions';

export namespace NPositions {
  export type ModelPosition = {
    Id: number;
    Name: string | null;
    Description: string | null;
    IsDeleted: boolean;
    MigrateId: number | null;
    Roles: ModelItem[] | null;
  };

  export type PositionForSystem = {
    Id: number;
    Name: string | null;
    IdS: string | null;
  };
}
